import {Pipe, PipeTransform} from '@angular/core';
import {RaceCommercialItem} from "@model";
import {CurrencyPipe} from "./currency.pipe";

@Pipe({
  name: 'raceCommercialItemsMinPriceFormat'
})
export class RaceCommercialItemsMinPriceFormatPipe implements PipeTransform {

  constructor(private currencyPipe:CurrencyPipe ) {
  }

  transform(raceCommercialItems:RaceCommercialItem[] | undefined, currencyLabel: string = ""): string | undefined {
    let minPrice:number|undefined =  this.getRaceCommercialItemsMinPrice(raceCommercialItems);
    return this.currencyPipe.transform(minPrice, currencyLabel);
  }

  getRaceCommercialItemsMinPrice(raceCommercialItems:RaceCommercialItem[] | undefined): number|undefined {
    if (raceCommercialItems === undefined) {
      return undefined;
    } else if (raceCommercialItems.length === 0) {
      return undefined;
    } else {
      let minPrice = undefined;
      for (let raceCommercialItem of raceCommercialItems) {
        if (raceCommercialItem.priceConstantByPeriod === true) {
          if (minPrice === undefined) {
            minPrice = raceCommercialItem.price!;
          }
          if ((raceCommercialItem.price ?? 0) < minPrice) {
            minPrice = raceCommercialItem.price!;
          }
        } else if (raceCommercialItem.priceConstantByPeriod === false && raceCommercialItem.periods) {
          for (let period of raceCommercialItem.periods) {
            if (minPrice === undefined) {
              minPrice = period.price!;
            }
            if ((period.price ?? 0) < minPrice) {
              minPrice = period.price!;
            }
          }
        }
      }
      return minPrice;
    }
  }
}
